export default class PhoneMobile {
    constructor(button) {
        this.button = button;
        this.phonesContainer = document.querySelector('.header-mobile__phones');
        this.overlay = document.querySelector('.header__overlay');
        this.buttonClose = this.phonesContainer.querySelector('.header-mobile__phones-close');
        this.buttonMenu = document.querySelector('.header-mobile__burger');
        this.mobileMenu = document.querySelector('.mobile-menu');

        this.eventRegister();
    }

    openPhoneList() {
        let height = this.phonesContainer.scrollHeight + 'px';
        if (this.mobileMenu.classList.contains('mobile-menu__is-open')) {
            return;
        }
        this.phonesContainer.style.height = height;
        this.overlay.style.display = 'block';
        this.overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        this.overlay.style.zIndex = '100';
    }
    closePhoneList() {
        this.phonesContainer.style.height = '';
        this.overlay.style.display = '';
        this.overlay.style.zIndex = '';
        this.overlay.style.removeProperty('background-color');
    }
    eventRegister() {
        this.button.addEventListener('click', () => {
            this.openPhoneList();
        });
        this.overlay.addEventListener('click', () => {
            this.closePhoneList();
        });
        this.buttonClose.addEventListener('click', () => {
            this.closePhoneList();
        });
        this.buttonMenu.addEventListener('click', () => {
            this.closePhoneList();
        });
    }
}
